import React, { useContext } from 'react';
import { Grid, Button, Typography, TextField as MuiTextField, FormControlLabel, Checkbox } from '@mui/material';
import { Field, FormikProps, useFormikContext } from 'formik';
import { TicketCategory, ticketCategoryDetailsContext } from '../TicketCategoryDetailsContext';
import { ChromePicker, ColorResult } from 'react-color';
import TicketCategorySubCategories from './TicketCategorySubCategories';
import { useIntl } from "react-intl";
import { LocalizationIds } from "helpers/Localizations";
import { localeContext } from 'helpers/Locale/LocaleManager';


interface IProps {
    formProps: FormikProps<any>
}

let TicketCategoryForm = ({ formProps }: IProps) => {
    let service = useContext(ticketCategoryDetailsContext);
    let localeService = useContext(localeContext);
    let form = useFormikContext<TicketCategory>();

    let { formatMessage } = useIntl();


    let handleChangeColor = (color: ColorResult, event: any) => {
        var newColor = form.values.color;
        if (color && color.rgb.a)
            newColor = color.hex + Math.round(color.rgb.a * 255).toString(16);
        else if (color) {
            newColor = color.hex;
        }

        formProps.setFieldValue('color', newColor);
    }

    return (
        <Grid container>
            {localeService.locales.map((locale, ix) =>
                <React.Fragment key={ix}>
                    <Grid item xs={6}>
                        <MuiTextField
                            size="small"
                            label={`${formatMessage({ id: LocalizationIds.Name })} (${formatMessage({ id: locale.value })})`}
                            value={service.categoryName[locale.key]}
                            onChange={(e: any) => service.updateName(e.target.value, locale.key)}
                        />
                    </Grid>
                </React.Fragment>
            )}

            <Grid item xs={12} md={6}>
                <FormControlLabel
                    label="Da cliente"
                    name="fromCustomer"
                    value={formProps.values.fromCustomer}
                    checked={formProps.values.fromCustomer}
                    onChange={(e: any) => formProps.setFieldValue('fromCustomer', e.target.checked)}
                    control={<Field type="checkbox" color="secondary" name="fromCustomer" component={Checkbox} />}
                />
            </Grid>

            <Grid item xs={12}>
                <TicketCategorySubCategories />
            </Grid>


            <Grid item xs={12} md={6}>
                <Typography>Color</Typography>
                <ChromePicker
                    color={formProps.values.color}
                    onChange={handleChangeColor}
                />
            </Grid>

            <Grid item xs />
            <Grid item>
                <Button type="submit" variant="contained">
                    Salva
                </Button>
            </Grid>
        </Grid>
    );
}

export default TicketCategoryForm;